import { render, staticRenderFns } from "./PremiumBusiness.vue?vue&type=template&id=2bda2c16&"
import script from "./PremiumBusiness.vue?vue&type=script&lang=js&"
export * from "./PremiumBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports